/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_LaptopsInputs */

const he_home_category_laptops = /** @type {(inputs: Home_Category_LaptopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחשבים ניידים`)
};

const en_home_category_laptops = /** @type {(inputs: Home_Category_LaptopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laptops`)
};

/**
* | output |
* | --- |
* | "Laptops" |
*
* @param {Home_Category_LaptopsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_laptops = /** @type {((inputs?: Home_Category_LaptopsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_LaptopsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_laptops(inputs)
	return en_home_category_laptops(inputs)
});